(function(angular, defineProperty) {
    'use strict';

    // similar to c# StringBuilder, but with much less functionality (only a subset of functions)
    // will make it easier to port code from C# to js, if necessary

    var newLine = '\r\n';

    angular.module('aprima-core').factory('StringBuilder', [
        '_',
        StringBuilderFactory,
    ]);
    
    function StringBuilderFactory(
        _
    ) {
        var service = {
            init: init,
        };
        
        return service;
        
        function init(initialStr) {
            var sb = new StringBuilder(initialStr);
            return sb;
        }

        function StringBuilder(initialStr) {
            var self = this;
            
            var baseStr = initialStr || '';

            self.Append = append;
            self.AppendLine = appendLine;
            self.ToString = toString;
            defineProperty(self, 'Length', {
                get: stringLength,
                enumerable: true,
                configurable: false,
            });
            
            function append(str) {
                baseStr += str;
                return self;
            }

            function appendLine(str) {
                if(!_.isNil(str) && !_.isNaN(str)) {
                    baseStr += str;
                }
                baseStr += newLine;
                return self;
            }
            
            function stringLength() {
                return baseStr.length;
            }
            
            function toString() {
                return baseStr;
            }
        }
    }

})(window.angular, window.Object.defineProperty);
